export const NewApplicationSidebar = {
    'MPSCONNECTIONS': {
     "type": "applicationdrawer",
     "order": 2,
     "key": "drawer",
     "options": {
         "icon": "alarm",
         "open": true,
         "iconsonly": true,
         anchor: 'right',
        orientation: 'vertical',
         "items": [

             {
                 "type": "menu",
                 "title": "Site Reviews",
                 "icon": "fa fa-sticky-note-o",
                 "materialicon": "edit_road",
                 "style": {
                     'color': '#b26a00'
                 },
                 "link": [
                     {
                         "routes": [
                             {
                                 "route": "/Records",
                                 "routeParams": "key",
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid"
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid1"
                             },
                             {
                                 "route": "/sitereview",
                             },
                         ],
                     }
                 ],
                 "key": "sitereview"
             },
             {
                "type": "menu",
                "title": "PLSS",
                "icon": "fa fa-sticky-note-o",
                "materialicon": "beenhereoutlined",
                "style": {
                    'color': '#607d8b'
                },
                "link": [
                    {
                        "routes": [
                            {
                                "route": "/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },
                            {
                                "route": "/taxlots",
                            },
                        ]
                    }
                ],
                "key": "taxlots"
            },
             {
                "type": "menu",
                "title": "Associate Inquiries",
                "icon": "fa fa-sticky-note-o",
                "materialicon": "settings_ethernet",
                "style": {
                    'color': '#148035'
                },
                "link": [
                    {
                        "routes": [
                            {
                                "route": "/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },
                            {
                                "route": "/assosciateinquiries",
                            },
                        ],
                    }
                ],
                "key": "assosciateinquiries"
            },

             {
                 "type": "menu",
                 "title": "Contacts",
                 "icon": "fa fa-user-circle-o",
                 "materialicon": "contacts",
                 "style": {
                     'color': '#64b5f6'
                 },
                 "link": [
                     {
                         "routes": [
                             {
                                 "route": "/Records",
                                 "routeParams": "key",
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid"
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid1"
                             },
                             {
                                 "route": "/contacts",
                             },
                         ],
                     }
                 ],
                 key: 'contacts'
             },
            //  {
            //      "type": "menu",
            //      "title": "Multiple Locations",
            //      "icon": "fa fa-sticky-note-o",
            //      "materialicon": "edit_location",
            //      "style": {
            //          'color': '#607d8b'
            //      },
            //      "link": [
            //          {
            //              "routes": [
            //                  {
            //                      "route": "/Records",
            //                      "routeParams": "key",
            //                  },
            //                  {
            //                      "route": "",
            //                      "routeParams": "routeid"
            //                  },
            //                  {
            //                      "route": "",
            //                      "routeParams": "routeid1"
            //                  },
            //                  {
            //                      "route": "/multiplelocations",
            //                  },
            //              ]
            //          }
            //      ],
            //      "key": "multiplelocations"
            //  },
             {
                 "type": "menu",
                 "title": "Supplemental Review & Routing",
                 "icon": "fa fa-envelope-o",
                 "materialicon": "call_to_action",
                 "style": {
                     'color': '#6b2037'
                 },
                 "link": [
                     {
                         "routes": [
                             {
                                 "route": "/Records",
                                 "routeParams": "key",
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid"
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid1"
                             },
                             {
                                 "route": "/routing",
                             },
                         ],
                     }
                 ],
                 key: 'routing'
             },
              // {
             //     "type": "menu",
             //     "title": "Workflow",
             //     "icon": "fa fa-files-o",
             //     "materialicon": "call_split",
             //     "style": {
             //         'color': '#3e2723'
             //     },
             //     button: {
             //         type: 'slidingbutton',
             //         "materialicon": "call_split",
             //         "key": "workflowbutton",
             //         "options": {
             //             "icon": true,
             //             "name": "Workflow",
             //             "customstyling": true,
             //             "buttonprops": {
             //                 "text": "Workflow"
             //             }
             //         },
             //         components: [
             //             NewApplicationWorkflow
             //         ]
             //     },
             //     key: 'workflow'
             // },
             {
                 "type": "menu",
                 "title": "Comments",
                 "icon": "fa fa-sticky-note-o",
                 "materialicon": "note",
                 "style": {
                     'color': '#b26a00'
                 },
                 "link": [
                     {
                         "routes": [
                             {
                                 "route": "/Records",
                                 "routeParams": "key",
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid"
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid1"
                             },
                             {
                                 "route": "/notes",
                             },
                         ],
                     }
                 ],
                 "key": "notes"
             },
             {
                 "type": "menu",
                 "title": "Inspections",
                 "icon": "fa fa-sticky-note-o",
                 "materialicon": "policy",
                 "style": {
                     'color': '#b26a00'
                 },
                 "link": [
                     {
                         "routes": [
                             {
                                 "route": "/Records",
                                 "routeParams": "key",
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid"
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid1"
                             },
                             {
                                 "route": "/inspections",
                             },
                         ],
                     }
                 ],
                 "key": "inspections"
             },
            
             {
                 "type": "menu",
                 "title": "Attachments",
                 "icon": "fa fa-paperclip",
                 "materialicon": "attach_file",
                 "style": {
                     'color': '#f48fb1'
                 },
                 "link": [
                     {
                         "routes": [
                             {
                                 "route": "/Records",
                                 "routeParams": "key",
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid"
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid1"
                             },
                             {
                                 "route": "/attachments",
                             },
                         ],
                     }
                 ],
                 "key": "attachments"
             },
             {
                 "type": "menu",
                 "title": "Images",
                 "icon": "fa fa-files-o",
                 "materialicon": "wallpaper",
                 "style": {
                     'color': '#ffb300'
                 },
                 "link": [
                     {
                         "routes": [
                             {
                                 "route": "/Records",
                                 "routeParams": "key",
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid"
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid1"
                             },
                             {
                                 "route": "/images",
                             },
                         ],
                     }
                 ],
                 key: 'images'
             },
             {
                 "type": "menu",
                 "title": "Notices",
                 "icon": "fa fa-files-o",
                 "materialicon": "tab",
                 "style": {
                     'color': '#8bc34a'
                 },
                 "link": [
                     {
                         "routes": [
                             {
                                 "route": "/Records",
                                 "routeParams": "key",
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid"
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid1"
                             },
                             {
                                 "route": "/notices",
                             },
                         ],
                     }
                 ],
                 key: 'notices'
             },
             {
                 "type": "menu",
                 "title": "Shared Discussions",
                 "icon": "fa fa-files-o",
                 "materialicon": "chat",
                 "style": {
                     'color': '#607d8b'
                 },
                 "link": [
                     {
                         "routes": [
                             {
                                 "route": "/Records",
                                 "routeParams": "key",
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid"
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid1"
                             },
                             {
                                 "route": "/discussions",
                             },
                         ],
                     }
                 ],
                 key: 'discussions'
             },
             {
                "type": "menu",
                "title": "Billing",
                "icon": "fa fa-dollar-sign",
                "materialicon": "attach_money",
                "style": {
                    'color': '#907d8b'
                },
                "link": [
                    {
                        "routes": [
                            {
                                "route": "/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },
                            {
                                "route": "/billing",
                            },
                        ],
                    }
                ],
                key: 'billing'
            },
             {
                 "type": "menu",
                 "title": "Notification Log",
                 "icon": "fa fa-envelope-o",
                 "materialicon": "notifications_active",
                 "style": {
                     'color': '#40c4ff'
                 },
                 "link": [
                     {
                         "routes": [
                             {
                                 "route": "/Records",
                                 "routeParams": "key",
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid"
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid1"
                             },
                             {
                                 "route": "/notificationlog",
                             },
                         ],
                     }
                 ],
                 "key": "notificationlog"
             },
             {
                 "type": "menu",
                 "title": "Permit Amendments",
                 "icon": "fa fa-sticky-note-o",
                 "materialicon": "approval",
                 "style": {
                     'color': '#b26a00'
                 },
                 "link": [
                     {
                         "routes": [
                             {
                                 "route": "/Records",
                                 "routeParams": "key",
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid"
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid1"
                             },
                             {
                                 "route": "/permitamendments",
                             },
                         ],
                     }
                 ],
                //  hidecondition: [{ Name: "permitstage", Value: "WORK_PERMIT_APPROVED_EXTENDED_REACTIVATED" ,notEquals:true}],
                 "key": "permitamendments"
             },              
             {
                 "type": "menu",
                 "title": "History",
                 "icon": "fa fa-files-o",
                 "materialicon": "history",
                 "style": {
                     'color': '#f44336'
                 },
                 "link": [
                     {
                         "routes": [
                             {
                                 "route": "/Records",
                                 "routeParams": "key",
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid"
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid1"
                             },
                             {
                                 "route": "/history",
                             },
                         ],
                     }
                 ],
                 key: 'history'
             },
         ]
     }
 },
     'MPSWHROW': {
      "type": "applicationdrawer",
      "order": 2,
      "key": "drawer",
      "options": {
          "icon": "alarm",
          "open": true,
          "iconsonly": true,
          anchor: 'right',
         orientation: 'vertical',
          "items": [
              {
                  "type": "menu",
                  "title": "Additional Contacts",
                  "icon": "fa fa-user-circle-o",
                  "materialicon": "contacts",
                  "style": {
                      'color': '#64b5f6'
                  },
                  "link": [
                      {
                          "routes": [
                              {
                                  "route": "/Records",
                                  "routeParams": "key",
                              },
                              {
                                  "route": "",
                                  "routeParams": "routeid"
                              },
                              {
                                  "route": "",
                                  "routeParams": "routeid1"
                              },
                              {
                                  "route": "/contacts",
                              },
                          ],
                      }
                  ],
                  key: 'contacts'
              },
            //   {
            //     "type": "menu",
            //     "title": "PLSS",
            //     "icon": "fa fa-sticky-note-o",
            //     "materialicon": "beenhereoutlined",
            //     "style": {
            //         'color': '#607d8b'
            //     },
            //     "link": [
            //         {
            //             "routes": [
            //                 {
            //                     "route": "/Records",
            //                     "routeParams": "key",
            //                 },
            //                 {
            //                     "route": "",
            //                     "routeParams": "routeid"
            //                 },
            //                 {
            //                     "route": "",
            //                     "routeParams": "routeid1"
            //                 },
            //                 {
            //                     "route": "/taxlots",
            //                 },
            //             ]
            //         }
            //     ],
            //     "key": "taxlots"
            // },
            {
                "type": "menu",
                "title": "PLSS Locations",
                "icon": "fa fa-sticky-note-o",
                "materialicon": "edit_location",
                "style": {
                    'color': '#2e8b57'
                },
                "link": [
                    {
                        "routes": [
                            {
                                "route": "/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },
                            {
                                "route": "/multiplelocations",
                            },
                        ]
                    }
                ],
                "key": "multiplelocations"
            },
            {
                "type": "menu",
                "title": "Attachments",
                "icon": "fa fa-paperclip",
                "materialicon": "attach_file",
                "style": {
                    'color': '#f48fb1'
                },
                "link": [
                    {
                        "routes": [
                            {
                                "route": "/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },
                            {
                                "route": "/attachments",
                            },
                        ],
                    }
                ],
                "key": "attachments"
            },
            {
                "type": "menu",
                "title": "Images",
                "icon": "fa fa-files-o",
                "materialicon": "wallpaper",
                "style": {
                    'color': '#ffb300'
                },
                "link": [
                    {
                        "routes": [
                            {
                                "route": "/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },
                            {
                                "route": "/images",
                            },
                        ],
                    }
                ],
                key: 'images'
            },
            {
                "type": "menu",
                "title": "Comments",
                "icon": "fa fa-sticky-note-o",
                "materialicon": "note",
                "style": {
                    'color': '#b26a00'
                },
                "link": [
                    {
                        "routes": [
                            {
                                "route": "/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },
                            {
                                "route": "/notes",
                            },
                        ],
                    }
                ],
                "key": "notes"
            },
            {
                "type": "menu",
                "title": "Staff Reviews",
                "icon": "fa fa-envelope-o",
                "materialicon": "group_add",
                "style": {
                    'color': '#568203'
                },
                "link": [
                    {
                        "routes": [
                            {
                                "route": "/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },
                            {
                                "route": "/routing",
                            },
                        ],
                    }
                ],
                key: 'routing'
            },
            {
                "type": "menu",
                "title": "Inspections",
                "icon": "fa fa-sticky-note-o",
                "materialicon": "policy",
                "style": {
                    'color': '#b26a00'
                },
                "link": [
                    {
                        "routes": [
                            {
                                "route": "/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },
                            {
                                "route": "/inspections",
                            },
                        ],
                    }
                ],
                "key": "inspections"
            },
            
              
               // {
              //     "type": "menu",
              //     "title": "Workflow",
              //     "icon": "fa fa-files-o",
              //     "materialicon": "call_split",
              //     "style": {
              //         'color': '#3e2723'
              //     },
              //     button: {
              //         type: 'slidingbutton',
              //         "materialicon": "call_split",
              //         "key": "workflowbutton",
              //         "options": {
              //             "icon": true,
              //             "name": "Workflow",
              //             "customstyling": true,
              //             "buttonprops": {
              //                 "text": "Workflow"
              //             }
              //         },
              //         components: [
              //             NewApplicationWorkflow
              //         ]
              //     },
              //     key: 'workflow'
              // },
              
              
              
              {
                  "type": "menu",
                  "title": "Shared Discussions",
                  "icon": "fa fa-files-o",
                  "materialicon": "chat",
                  "style": {
                      'color': '#607d8b'
                  },
                  "link": [
                      {
                          "routes": [
                              {
                                  "route": "/Records",
                                  "routeParams": "key",
                              },
                              {
                                  "route": "",
                                  "routeParams": "routeid"
                              },
                              {
                                  "route": "",
                                  "routeParams": "routeid1"
                              },
                              {
                                  "route": "/discussions",
                              },
                          ],
                      }
                  ],
                  key: 'discussions'
              },
              {
                "type": "menu",
                "title": "Notices",
                "icon": "fa fa-files-o",
                "materialicon": "tab",
                "style": {
                    'color': '#8bc34a'
                },
                "link": [
                    {
                        "routes": [
                            {
                                "route": "/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },
                            {
                                "route": "/notices",
                            },
                        ],
                    }
                ],
                key: 'notices'
            },
              {
                "type": "menu",
                "title": "Permit Amendments",
                "icon": "fa fa-sticky-note-o",
                "materialicon": "approval",
                "style": {
                    'color': '#b26a00'
                },
                "link": [
                    {
                        "routes": [
                            {
                                "route": "/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },
                            {
                                "route": "/permitamendments",
                            },
                        ],
                    }
                ],
                //hidecondition: [{ Name: "permitstage", Value: "WORK_PERMIT_APPROVED_EXTENDED_REACTIVATED" ,notEquals:true}],
                "key": "permitamendments"
            }, 
            //   {
            //     "type": "menu",
            //     "title": "Billing",
            //     "icon": "fa fa-dollar-sign",
            //     "materialicon": "chat",
            //     "style": {
            //         'color': '#607d8b'
            //     },
            //     "link": [
            //         {
            //             "routes": [
            //                 {
            //                     "route": "/Records",
            //                     "routeParams": "key",
            //                 },
            //                 {
            //                     "route": "",
            //                     "routeParams": "routeid"
            //                 },
            //                 {
            //                     "route": "",
            //                     "routeParams": "routeid1"
            //                 },
            //                 {
            //                     "route": "/billing",
            //                 },
            //             ],
            //         }
            //     ],
            //     key: 'billing'
            // },
              {
                  "type": "menu",
                  "title": "Notification Log",
                  "icon": "fa fa-envelope-o",
                  "materialicon": "notifications_active",
                  "style": {
                      'color': '#40c4ff'
                  },
                  "link": [
                      {
                          "routes": [
                              {
                                  "route": "/Records",
                                  "routeParams": "key",
                              },
                              {
                                  "route": "",
                                  "routeParams": "routeid"
                              },
                              {
                                  "route": "",
                                  "routeParams": "routeid1"
                              },
                              {
                                  "route": "/notificationlog",
                              },
                          ],
                      }
                  ],
                  "key": "notificationlog"
              },
              
            {
                  "type": "menu",
                  "title": "History",
                  "icon": "fa fa-files-o",
                  "materialicon": "history",
                  "style": {
                      'color': '#f44336'
                  },
                  "link": [
                      {
                          "routes": [
                              {
                                  "route": "/Records",
                                  "routeParams": "key",
                              },
                              {
                                  "route": "",
                                  "routeParams": "routeid"
                              },
                              {
                                  "route": "",
                                  "routeParams": "routeid1"
                              },
                              {
                                  "route": "/history",
                              },
                          ],
                      }
                  ],
                  key: 'history'
              },
          ]
      }

      
  },
  'MPSINQUIRIES': {
     "type": "applicationdrawer",
     "order": 2,
     "key": "drawer",
     "options": {
         "icon": "alarm",
         "open": true,
         "iconsonly": true,
         anchor: 'right',
        orientation: 'vertical',
         "items": [
             
             {
                 "type": "menu",
                 "title": "ParcelID's",
                 // "icon": "fa fa-inventory",
                 "materialicon": "local_post_office",
                 "style": {
                     'color': '#f44336'
                 },
                 "link": [
                     {
                         "routes": [
                             {
                                 "route": "/Records",
                                 "routeParams": "key",
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid"
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid1"
                             },
                             {
                                 "route": "/parcelids",
                             },
                         ],
                     }
                 ],
                 "key": "parcelids"
             },
             {
                "type": "menu",
                "title": "Contacts",
                "icon": "fa fa-user-circle-o",
                "materialicon": "contacts",
                "style": {
                    'color': '#64b5f6'
                },
                "link": [
                    {
                        "routes": [
                            {
                                "route": "/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },
                            {
                                "route": "/contacts",
                            },
                        ],
                    }
                ],
                key: 'contacts'
            },
             {
                 "type": "menu",
                 "title": "Attachments",
                 "icon": "fa fa-paperclip",
                 "materialicon": "attach_file",
                 "style": {
                     'color': '#f48fb1'
                 },
                 "link": [
                     {
                         "routes": [
                             {
                                 "route": "/Records",
                                 "routeParams": "key",
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid"
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid1"
                             },
                             {
                                 "route": "/attachments",
                             },
                         ],
                     }
                 ],
                 "key": "attachments"
             },

{
                    "type": "menu",
                    "title": "Images",
                    "icon": "fa fa-files-o",
                    "materialicon": "wallpaper",
                    "style": {
                        'color': '#ffb300'
                    },
                    "link": [
                        {
                            "routes": [
                                {
                                    "route": "/Records",
                                    "routeParams": "key",
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid"
                                },
                                {
                                    "route": "",
                                    "routeParams": "routeid1"
                                },
                                {
                                    "route": "/images",
                                },
                            ],
                        }
                    ],
                    key: 'images'
                },
             {
                 "type": "menu",
                 "title": "Comments",
                 "icon": "fa fa-sticky-note-o",
                 "materialicon": "note",
                 "style": {
                     'color': '#b26a00'
                 },
                 "link": [
                     {
                         "routes": [
                             {
                                 "route": "/Records",
                                 "routeParams": "key",
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid"
                             },
                             {
                                 "route": "",
                                 "routeParams": "routeid1"
                             },
                             {
                                 "route": "/notes",
                             },
                         ],
                     }
                 ],
                 "key": "notes"
             },

             {
                "type": "menu",
                "title": "History",
                "icon": "fa fa-files-o",
                "materialicon": "history",
                "style": {
                    'color': '#f44336'
                },
                "link": [
                    {
                        "routes": [
                            {
                                "route": "/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },
                            {
                                "route": "/history",
                            },
                        ],
                    }
                ],
                key: 'history'
            },
            
             {
                "type": "menu",
                "title": "Development Requests",
                "key": "developmentrequests",
                "materialicon": "nature_people",
                // "icon": "fa fa-envelope-o",
                "style": {
                    'color': '#c90a5c'
                },
                "link": [
                    {
                        "routes": [
                            {
                                "route": "/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },
                            {
                                "route": "/developmentrequests",
                            },
                        ],
                    }
                ],
            },
         ]
     }

     
 },
}